export default __webpack_public_path__ + "static/media/_0001_ohno.253e200b.png";